if (!customElements.get('estimated-delivery')) {
  customElements.define(
    'estimated-delivery',
    class EstimatedDelivery extends HTMLElement {
      // Counts business days only (Mon–Fri). US holidays are not excluded, so the
      // result is labelled "estimated" in the UI.
      static addBusinessDays(fromDate, days) {
        const date = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          const weekday = date.getDay();
          if (weekday !== 0 && weekday !== 6) added++;
        }
        return date;
      }

      static toISODate(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
      }

      connectedCallback() {
        const handling = Number(this.dataset.handlingDays);
        const transitMin = Number(this.dataset.transitMin);
        const transitMax = Number(this.dataset.transitMax);
        if (!handling || !transitMin || !transitMax) return;

        const today = new Date();
        const start = EstimatedDelivery.addBusinessDays(today, handling + transitMin);
        const end = EstimatedDelivery.addBusinessDays(today, handling + Math.max(transitMin, transitMax));
        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        });

        this.setTime(this.querySelector('[data-start]'), start, format);
        this.setTime(this.querySelector('[data-end]'), end, format);
        this.hidden = false;
      }

      setTime(element, date, format) {
        if (!element) return;
        element.setAttribute('datetime', EstimatedDelivery.toISODate(date));
        element.textContent = format.format(date);
      }
    },
  );
}
